module.exports = __webpack_public_path__ + "static/sc_12-6385d3758dc35e45835a8f23ac770b86.jpg";